@use '@fukuri-admins/ui/layout' as *;

@keyframes skeletonAnimation {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.skeleton {
  position: relative;
  width: var(--skeleton-width);
  height: var(--skeleton-height);
  overflow: hidden;
  background: #e1e8ee;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    content: '';
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0)
    );
    animation: skeletonAnimation 1.2s linear infinite;
  }
}

.inline {
  display: inline-block;
}

.block {
  display: block;
}

.radiusNone {
  border-radius: borderRadius('none');
}

.radiusXs {
  border-radius: borderRadius('xs');
}

.radiusSm {
  border-radius: borderRadius('sm');
}

.radiusMd {
  border-radius: borderRadius('md');
}

.radiusLg {
  border-radius: borderRadius('lg');
}

.radiusXl {
  border-radius: borderRadius('xl');
}

.radius2xl {
  border-radius: borderRadius('2xl');
}

.radius3xl {
  border-radius: borderRadius('3xl');
}

.radiusFull {
  border-radius: borderRadius('full');
}
